
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FtlAdditionalService from '@/modules/FTLModule/components/FtlAdditionalService/index.vue'

// types
import { FTLBidWaypointT } from '@/core/types/ftl_bids.types'

// constants
import { ADDITIONAL_SERVICES } from '@/core/constants/additional_services.constants'

// realisations
import { ftl_bids } from '@/core/realisations/ftl_bids.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        TheButton,
        FtlAdditionalService
    },
    props: {
        waypoint: {
            type: Object as PropType<FTLBidWaypointT>,
            required: true,
        },
        bidId: {
            type: Number,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        }
    },
    setup(props) {
        const notifications = useNotifications()

        const state = reactive({
            is_print_invoice_loading: false,
        })

        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const saveFile = (content: Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const onPrintInvoice = async () => {
            if (state.is_print_invoice_loading) return

            try {
                state.is_print_invoice_loading = true

                const response = await ftl_bids.printFtlBidWaypointInvoice(props.bidId, props.index)
                saveFile(response, `Накладная FTL заявки ${props.bidId} пункта ${props.index + 1}`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При распечатке накладной произошла ошибка',
                })
            } finally {
                state.is_print_invoice_loading = false
            }
        }

        return {
            state,
            formatAmount,
            onPrintInvoice,
            ADDITIONAL_SERVICES,
        }
    }
})
